module.exports = __webpack_public_path__ + "static/media/protection.d334cdbf.svg";